import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowBigRight = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 28C13.794 28 12 26.206 12 24C12 22.958 12.399 21.971 13.123 21.221C13.129 21.215 13.136 21.208 13.142 21.202L14.368 20H8.00101C5.79501 20 4.00101 18.206 4.00101 16C4.00101 13.794 5.79501 12 8.00101 12H14.366L13.179 10.835C12.428 10.083 12.001 9.053 12.001 8C12.001 5.794 13.795 4 16.001 4C17.054 4 18.085 4.427 18.83 5.171L26.83 13.171C27.574 13.916 28.002 14.946 28.002 16C28.002 17.054 27.575 18.084 26.83 18.828L18.83 26.828C18.085 27.572 17.054 28 16.001 28H16ZM14.553 22.619C14.196 22.993 14 23.482 14 24C14 25.103 14.897 26 16 26C16.526 26 17.042 25.787 17.414 25.414L25.414 17.414C25.786 17.042 26 16.526 26 16C26 15.474 25.787 14.958 25.414 14.586L17.414 6.586C17.042 6.214 16.526 6 16 6C14.897 6 14 6.897 14 8C14 8.526 14.213 9.042 14.586 9.414L17.513 12.286C17.803 12.57 17.892 13.002 17.738 13.378C17.584 13.754 17.218 14 16.812 14H8.00001C6.89701 14 6.00001 14.897 6.00001 16C6.00001 17.103 6.89701 18 8.00001 18H16.815C17.221 18 17.587 18.246 17.741 18.622C17.895 18.998 17.806 19.43 17.516 19.714L14.554 22.62L14.553 22.619Z" />
	</svg>
);

export default ArrowBigRight;
